import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import { ThemeProvider } from './contexts/ThemeContext.tsx'
import { CVModalProvider } from './contexts/CVModalContext.tsx'
import { prefersReducedMotion } from './lib/motion.ts'
import './index.css'

if (!prefersReducedMotion()) {
  document.documentElement.classList.add('js-animations')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <CVModalProvider>
          <App />
          <Toaster
            position="bottom-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#111318',
                color: '#e4e7ee',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              },
            }}
          />
        </CVModalProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)